import React, { useEffect, useState } from "react";
import { getOrganwiseTests } from "../../api/api";
import rbdLogo from "../../Assets/rbdLogo.png";
import { TruncateText } from "../../common/TruncateText";
import "./HomePageCss/TestsSections.css";
import PackageDetailsModal from "../OurPackagesPageElements/PackageDetailsModel";
import { useCart } from "../../Contexts/Cart.contexts";
import { useNavigate } from "react-router-dom";

const HomeTestDetails = ({ organData, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [tests, setTests] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const { addToCart, cartItems, setCartItems } = useCart();
  const navigator = useNavigate();

  /* ---------------- API CALL ---------------- */
  useEffect(() => {
    if (organData?.organId) {
      fetchDepartmentTests();
    }
  }, [organData]);

  const fetchDepartmentTests = async () => {
    try {
      setLoading(true);
      const payload = { organId: organData.organId };
      const res = await getOrganwiseTests(payload);
      setTests(res?.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch tests", err);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- VIEW DETAILS ---------------- */
  const handleViewDetails = (card) => {
    setSelectedPackage(card);
    setIsModalOpen(true);
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      {/* MODAL BOX */}
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          width: "92%",
          maxWidth: "1200px",
          maxHeight: "85vh",
          background: "#fff",
          borderRadius: "12px",
          padding: "18px 20px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* CLOSE BUTTON */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            border: "none",
            background: "transparent",
            fontSize: "18px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          ✖
        </button>

        {/* TITLE */}
        <h2
          style={{
            marginBottom: "14px",
            fontSize: "20px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          {organData?.organName}
        </h2>

        {/* CONTENT */}
        {loading ? (
          <p style={{ textAlign: "center" }}>Loading tests...</p>
        ) : tests.length > 0 ? (
          <div className="mainPackageCardSectionhomeTest">
            {tests.slice(0, 10).map((card, index) => {
              /* -------- CART LOGIC (PER CARD) -------- */
              const isAdded = cartItems?.some(
                (item) => item.id === card.service_id
              );

              const handleToggleCart = () => {
                if (isAdded) {
                  setCartItems((prev) =>
                    prev.filter((item) => item.id !== card.service_id)
                  );
                } else {
                  addToCart({
                    id: card.service_id,
                    name: card.service_name,
                    price: card.price,
                    type: "TEST",
                    ...card,
                  });
                }
              };

              return (
                <div key={index} className="carouselCardWrapperhomeTest">
                    <div className="packageCard mainPackageCard wide-card organ-packageCard compact-test-card">

                    <div className="cornerImage">
                      <div className="upperCardText">
                        <img className="logoimg" src={rbdLogo} alt="RBD logo" />
                      </div>
                    </div>

                    <div className="cardTitlePack mainpackageTitlePack vgvfkl">
                      <h2 style={{ color: "gray", fontSize: "16px" }}>
                        <TruncateText
                          text={card?.service_name}
                          maxLength={25}
                        />
                      </h2>
                      <span
                        style={{
                          color: "#555",
                          fontSize: "0.8rem",
                        }}
                      >
                        Test Key:{" "}
                        <TruncateText text={card?.service_key} maxLength={20} />
                      </span>
                    </div>

                    <div className="testPackageMidSection">
                      <div className="priceSection">
                        <h3 style={{ margin: 0, fontSize: "1rem" }}>
                          ₹ {card.price}
                        </h3>
                      </div>
                    </div>

                    <div className="cardLowerSec">
                      <button
                        className="rbdButton"
                        onClick={() => handleViewDetails(card)}
                      >
                        <span className="btn-text">View Details</span>
                      </button>

                      <button
                        className={`rbdButton addCartBtn ${
                          isAdded ? "added" : ""
                        }`}
                        onClick={handleToggleCart}
                      >
                       
                        <span className="btn-text">  {isAdded ? "Added" : "Add to Cart"}</span>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p style={{ textAlign: "center" }}>No tests available</p>
        )}
        {tests.length > 0 && (
          <div style={{ textAlign: "center" }}>
            <button
              className="rbdButton"
              onClick={() => navigator("/service/pathology")}
            //   style={{
            //     padding: "10px 24px",
            //     fontSize: "14px",
            //     borderRadius: "8px",
            //   }}
            >
             <span className="btn-text">View All Tests</span>
            </button>
          </div>
        )}
      </div>

      {/* PACKAGE DETAILS MODAL */}
      <PackageDetailsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        packageData={selectedPackage}
      />
    </div>
  );
};

export default HomeTestDetails;
